/**
 * @file       customDateAdapter
 * @version    1.0.0
 * @author     Boris Veits
 * @copyright  Copyright (c) 2018, MindShare HDV LLC.  All rights reserved.
 *             Property of MindShare HDV LLC.  This file cannot be used or
 *             altered in anyway without expressed written permission from
 *             MindShare HDV LLC.
 */
import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()

/**
 * @desc   - Custom date adapter that prevents parsing incomplete dates
 *           (avoids 01/01/2000 when user types partial input)
 */
class CustomDateAdapter extends NativeDateAdapter
{
    /**
     * @desc   - Override parse to return null for incomplete date strings
     * @access - public
     * @param  - value : string | number - the value to parse
     * @return - Date | null
     */
    override parse
    (
        value: string | number
    ): Date | null
    {
        let result;
        let dateStr;
        let parts;
        let month;
        let day;
        let year;
        let date;

        result = null;

        if (typeof value === 'string')
        {
            dateStr = value.trim();

            // Only parse if it matches MM/DD/YYYY format exactly
            if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateStr))
            {
                parts = dateStr.split('/');
                month = parseInt(parts[0], 10);
                day = parseInt(parts[1], 10);
                year = parseInt(parts[2], 10);

                if (month >= 1 && month <= 12 &&
                    day >= 1 && day <= 31 &&
                    year >= 1000)
                {
                    date = new Date(year, month - 1, day);
                    if (!isNaN(date.getTime()))
                    {
                        result = date;
                    }
                }
            }
        }
        else if (typeof value === 'number')
        {
            result = new Date(value);
        }

        return result;
    }

    /**
     * @desc   - Format date as MM/DD/YYYY
     * @access - public
     * @param  - date : Date - the date to format
     * @param  - displayFormat : Object - the display format
     * @return - string
     */
    override format
    (
        date: Date,
        displayFormat: Object
    ): string
    {
        let month;
        let day;
        let year;

        month = (date.getMonth() + 1).toString().padStart(2, '0');
        day = date.getDate().toString().padStart(2, '0');
        year = date.getFullYear();

        return `${month}/${day}/${year}`;
    }
}

export { CustomDateAdapter };
